import isEmpty from 'lodash/isEmpty';
import keys from 'lodash/keys';
import reduce from 'lodash/reduce';
import toPath from 'lodash/toPath';

export const partial = (fn:Function, ...args:any) => fn.bind(null, ...args);

export const omitEmpty = o => {
  return reduce(
    o,
    function(acc, value, key) {
      if (Array.isArray(value)) {
        // pass arrays without further processing
        acc[key] = value; 
      }
      else if (typeof value === 'object') {
        // clean objects recursively
        const val = omitEmpty(value);
        if (!isEmpty(val)) {
          acc[key] = val;
        }
        return acc;
      } else {
        // return all primitives untouched
        acc[key] = value;
      }
      return acc;
    },
    {}
  );
};

export const toErrorSchema = (errors) => {
  if (!errors) {
    return {};
  }
  return reduce(keys(errors), (errorSchema, key) => {
    const path = toPath(key);
    let parent = errorSchema;
    for (const segment of path.slice(0)) {
      if (!(segment in parent)) {
        parent[segment] = {};
      }
      parent = parent[segment];
    }
    
    if (Array.isArray(parent.__errors)) {
      // We store the list of errors for this node in a property named __errors
      // to avoid name collision with a possible sub schema field named
      // "errors" (see `validate.createErrorHandler`).
      parent.__errors = parent.__errors.concat(errors[key]);
    } else {
      parent.__errors = [errors[key]];
    }

    return errorSchema;
  }, {});
}


// WEBPACK FOOTER //
// ./src/utils/index.js